var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"academy"},[_c('li',[_c('img',{attrs:{"src":this.$store.state.api + _vm.src,"alt":""}})]),_c('li',[_c('h4',[_vm._v(_vm._s(_vm.academyName))])]),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }